<bz-dialog-layout [heading]="data.title" [subheading]="data.message || ''">
  <div bzDialogContent>
    <bz-input
      [(value)]="value"
      [placeholder]="data.placeholder || ''"
      [ariaLabel]="data.label || data.title"
    />
  </div>

  <div bzDialogActions>
    <bz-button variant="tertiary" type="button" (clicked)="cancel()">
      {{ data.cancelLabel || 'Cancel' }}
    </bz-button>
    <bz-button type="button" tone="secondary" [disabled]="!canConfirm" (clicked)="confirm()">
      {{ data.confirmLabel || 'Save' }}
    </bz-button>
  </div>
</bz-dialog-layout>
